import { AdobeAn } from './resultImage/lib';
import { dataURLtoBlob } from '../../../vendors/ngblib/utils/dataURLtoBlob';

const createjs = require('createjs/builds/1.0.0/createjs');

console.log('AdobeAn', AdobeAn);

class ResultImageGenerator {
    #canvas;
    #stage;
    #root;
    #value = 0;

    constructor(jsImagesStoreArr) {
        this.#canvas = document.getElementById('share-result-canvas');

        const comp = AdobeAn.getComposition('04AF873B120D41D0B29AE1A02A4D398A');
        const lib = comp.getLibrary();
        const images = comp.getImages();
        const ss = comp.getSpriteSheet();
        const { ssMetadata, properties } = lib;
        const { manifest } = properties;

        // Pass images to the lib
        manifest.forEach(({ id }) => {
            const loaded = jsImagesStoreArr[id];

            if (!loaded) return;

            const { image, src, error } = loaded;

            if (error) {
                // Try again
                image.src = src;
            }

            images[id] = loaded.image;
        });

        // Construct
        if (ssMetadata.length > 0) {
            for (let i = 0; i < ssMetadata.length; i += 1) {
                ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                    images: [images[ssMetadata[i].name]],
                    frames: ssMetadata[i].frames
                });
            }
        }
        // eslint-disable-next-line
        const root = new lib.share_result();
        const stage = new lib.Stage(this.#canvas);

        stage.addChild(root);

        AdobeAn.compositionLoaded(lib.properties.id);

        // RENDER
        console.log(root);
        // Initiate internal method:
        stage.update();

        // update
        root.setResult(this.#value);
        stage.update();

        this.#root = root;
        this.#stage = stage;
    }

    set value(val) {
        this.#value = val;

        this.#root.setResult(this.#value);
        this.#stage.update();
    }

    get value() {
        return this.#value;
    }

    getBlob() {
        return dataURLtoBlob(this.#canvas.toDataURL());
    }
}

let instance = null;

export const getResultImageGenerator = (jsImagesStoreArr) => {
    instance = instance || new ResultImageGenerator(jsImagesStoreArr);

    return instance;
};
